<template>
  <main id="home">
    <section class="flex flex-col xl:flex-row justify-evenly items-center pt-10 xl:pt-24">
      <div class="flex flex-col mx-6 p-2  xl:mx-16 xl:p-8 ">
        <img src="https://i.imgur.com/5Pdis9B.png" alt="name" class="name-image hoverZoom">
        <p class="text-secondary-color italic font-extrabold pb-4 pt-8 text-3xl">Full-Stack Web Developer</p>
        <p class="text-xl">I’m a <span class="section-title">full-stack developer</span> focused on building responsive, user-driven applications that turn complex ideas into practical digital solutions.</p>
      </div>
      
      <img src="https://i.imgur.com/ol6M0Im.jpg" alt="profile image" class="profile-image hoverZoom">
            
    </section>
    <section>
      <p class="xl:text-xl xl:px-8 mx-8 xl:mx-36 mt-16 xl:mt-10">Every moment holds <span class="section-title">potential</span>, a lesson I've carried throughout my journey. One of my most defining moments was acquiring U.S. Citizenship—a milestone that opened new opportunities and strengthened my drive to keep growing, learning, and building a better future.</p>
      <div class="intro-image-container">
        <img src="https://i.imgur.com/wCZdd8j.jpg" alt="Brian Receiving his Citizenship" class="intro-image">
      </div>
      
      <p class="xl:text-xl xl:px-8 mx-8 xl:mx-36 mt-8">My background in construction and operations taught me how to solve problems under pressure, lead teams, and deliver quality work in fast-paced environments. Today, I bring that same discipline and <span class="section-title">problem-solving</span> mindset into web development, where I focus on creating clean, functional, and scalable applications.</p>

      <p class="xl:text-xl xl:px-8 mx-8 xl:mx-36 mt-8">When I'm not working or building projects, I spend most of my time with my family. I enjoy baking with my daughter and look forward to the day she's old enough to join me on many <span class="section-title">hiking</span> adventures.</p>
      <div class="intro-image-container">
        <img src="https://i.imgur.com/6KieDZn.jpg" alt="Brian and family" class="intro-image-3">
      </div>

      <p class="xl:text-xl xl:px-8 mx-8 xl:mx-36 mt-8">As a developer, I’m passionate about building web solutions that help businesses improve operations, connect with users, and achieve <span class="section-title">measurable</span> results.</p>
      <img src="https://i.imgur.com/3hhfbsg.png" alt="text divider" class="divider">

    </section>
    <section id="experience">
      <MyExperience />
    </section>
    <section id="projects" class=" py-32">
      <UserProjects />
    </section>
    <section id="contact">
      <ContactMe />
    </section>
    <footer>
      <PageFooter />
    </footer>
  </main>
</template>

<script>
import MyExperience from './MyExperience.vue'
import UserProjects from './UserProjects.vue';
import ContactMe from './ContactMe.vue';
import PageFooter from '../components/PageFooter.vue'

export default {
  name: 'HomePage',
  components: {
    MyExperience,
    UserProjects,
    ContactMe,
    PageFooter
  },
}
</script>